export type EventModeItem = {
  number: number;
  iconActive: string;
  iconIdle: string;
  disabled?: boolean;
  activeLabel: string;
  idleLabel: string;
  url?: string;
};

type EventModeButtonsProps = {
  items: EventModeItem[];
  activeEventNumber: number | null;
  title: string;
  onTrigger: (item: EventModeItem) => void;
};

export default function EventModeButtons({
  items,
  activeEventNumber,
  title,
  onTrigger,
}: EventModeButtonsProps) {
  return (
    <div className="mb-2 flex-shrink-0">
      <p className="font-medium text-gray-700 text-xs mb-2">{title}</p>
      <div className="flex gap-2">
        {items.map((item) => {
          const isActive = activeEventNumber === item.number;
          const isDisabled = item.disabled;
          const baseClass =
            "flex-1 flex items-center justify-center gap-1.5 rounded-xl font-medium px-2 py-2 text-xs";
          const stateClass = isDisabled
            ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-50"
            : isActive
              ? "bg-red-500 text-white shadow-lg ring-2 ring-red-300 transition-all cursor-pointer active:scale-95"
              : "bg-orange-500 text-white shadow-lg transition-all cursor-pointer active:scale-95";
          return (
            <button
              key={item.number}
              onClick={() => !isDisabled && onTrigger(item)}
              disabled={isDisabled}
              className={`${baseClass} ${stateClass}`}
            >
              <i
                className={`${isActive ? item.iconActive : item.iconIdle} text-base`}
              ></i>
              {isActive ? item.activeLabel : item.idleLabel}
            </button>
          );
        })}
      </div>
    </div>
  );
}
